import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import Heading from '@cotyorg/ccx-atoms/Heading';
import { CardoCarousel } from '@cotyorg/ccx-organism-carousel';
import SectionHeader from '../../../../atoms/SectionHeader';

export const ProductCollection = ({ sectionHeadings, ctas }) => (
  <div className="product-collection-section">
    <div className="grid-container full">
      <div className="grid-x grid-margin-x pre-offset">
        <div className="cell">
          <SectionHeader>
            <Heading extraClass="section__title" level={2}>
              {R.path(['productCollection', 'heading'])(sectionHeadings)}
            </Heading>
          </SectionHeader>

          <CardoCarousel
            cardoProps={{
              cardoStoreDataKey: 'productCollectionCarousel',
              isTitleUnderlined: false,
              hasBackground: false,
              isSmallTitle: true,
              fullWidth: true,
              headingLevel: 5,
              showStarRating: false,
              fixedHeight: true,
              zoomOnHover: true,
              hideDescription: true,
              alignCenter: false,
            }}
            carouselProps={{
              carouselsStoreDataKey: 'productCollectionCarousel',
              headingLevel: 5,
              rightChevronIconSrc: '/ccx-files/assets/arrow-right-blue.svg',
              leftChevronIconSrc: '/ccx-files/assets/arrow-left-blue.svg',
            }}
            cardsPerPageMap={{
              xsmall: 1,
              small: 2,
              medium: 3,
              large: 4,
              xlarge: 4,
            }}
          />

          <div className="product-collection-background offset">
            {R.path(['productCollectionLink', 'text'], ctas) && (
              <div className="flex-container align-center">
                <a
                  className="homepage__cta"
                  href={R.path(['productCollectionLink', 'url'], ctas)}
                >
                  {R.path(['productCollectionLink', 'text'], ctas)}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

ProductCollection.propTypes = {
  sectionHeadings: PropTypes.instanceOf(PropTypes.object),
  ctas: PropTypes.objectOf(PropTypes.object),
};
